import * as api from './api'
import { THREE_HOUR } from '@/constants/time'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { checkTtlDate } from '@/helper'
import { CATEGORY } from '@/constants/localStorage'

export default {
  async loadData ({ commit }, { force = false } = {}) {
    const categoryLocal = getLocalData(CATEGORY)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (categoryLocal?.updateDate || 0),
      ttlTime: THREE_HOUR,
    })

    if (!force && categoryLocal && !isNeedUpdate) {
      commit('setData', categoryLocal.data)

      return { data: categoryLocal.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      setLocalData(CATEGORY, {
        updateDate: Date.now(),
        data: data.data
      })

      commit('setData', data.data)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      commit('setData', newData)

      setLocalData(CATEGORY, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(CATEGORY, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({ id }) => id !== payload )

      commit('setData', newData)

      setLocalData(CATEGORY, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  }
}